import { render, staticRenderFns } from "./NuevosIngresosComponent.vue?vue&type=template&id=510560b8"
import script from "./NuevosIngresosComponent.vue?vue&type=script&lang=js"
export * from "./NuevosIngresosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports